import React from "react";
import { Moon } from "lucide-react";

export default function Logo({ size = 28 }) {
  return (
    <div className="flex items-center gap-2" data-testid="logo">
      <div
        className="grid place-items-center rounded-full"
        style={{
          width: size + 8, height: size + 8,
          background: "linear-gradient(135deg, #BF953F, #FCF6BA, #AA771C)",
          color: "#0A0A0B",
        }}
      >
        <Moon size={size - 6} strokeWidth={2.4} />
      </div>
      <div className="leading-none">
        <div className="font-serif text-xl tracking-wide text-white">Moon</div>
        <div className="text-[10px] tracking-[0.3em] text-amber-400/80 font-mono uppercase">Hotel · Restaurant</div>
      </div>
    </div>
  );
}
